import { useState } from 'react';
import { Table } from 'antd';
import { TableTopPannel } from './TableTopPannel';
import { useLocation, useNavigate } from 'react-router-dom';
import LocalLoader from '../LocalLoader';

export default function CustomTable({
    className,
    tablePannelTitle,
    asyncFilter,
    onAddButtonClick,
    topPannelButtonText,
    searchInputPlaceholder,
    isLoading,
    withNavigation,
    withCustomNavigation,
    tableHeader,
    data,
    getFilteredData,
    withFilter,
    functionalCell = {},
    columnsDataMap = {},
    tableScroll,
    options,
    withSortBy,
    columnsWidth = {},
    datepicker,
    select,
    errors,
    additionalButtons,
}) {
    const navigate = useNavigate();
    const location = useLocation();

    const [filter, setFilter] = useState('');
    const [selectedOption, setSelectedOption] = useState(
        (options && options[0]) || {},
    );

    const generateTableHeader = (headers) =>
        headers.map((el, key) =>
            functionalCell[el]
                ? functionalCell[el]
                : {
                      title: el,
                      width: columnsWidth[key],
                      dataIndex: columnsDataMap[el]
                          ? columnsDataMap[el]
                          : el.toLowerCase().replace(/\s/g, '_'),
                      render: (text) => <span>{text || '-'}</span>,
                  },
        );

    const onInputChange = (e) => {
        setFilter(e.target.value);
    };

    const onAsyncInputChange = (e) => {
        setFilter(e.target.value);
        asyncFilter(e.target.value);
    };

    const setRowKey = (record) => record.id;

    const onHandleSortByChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    return (
        <>
            <TableTopPannel
                title={tablePannelTitle}
                onAddButtonClick={onAddButtonClick}
                onInputChange={asyncFilter ? onAsyncInputChange : onInputChange}
                inputValue={filter}
                buttonText={topPannelButtonText}
                searchInputPlaceholder={searchInputPlaceholder}
                withFilter={withFilter}
                onHandleSortByChange={onHandleSortByChange}
                options={options}
                selectedOption={selectedOption}
                withSortBy={withSortBy}
                datepicker={datepicker}
                select={select}
                isLoading={isLoading}
                additionalButtons={additionalButtons}
            />
            <LocalLoader size={30} isLoading={isLoading}>
                <Table
                    className={className}
                    components={
                        withNavigation
                            ? {
                                  header: {},
                                  body: {
                                      row: ({ ...props }) => {
                                          return (
                                              <tr
                                                  {...props}
                                                  onClick={() =>
                                                      withCustomNavigation
                                                          ? navigate(
                                                                `${withCustomNavigation}/${props['data-row-key']}/${withNavigation}`,
                                                            )
                                                          : navigate(
                                                                `${location.pathname}/${props['data-row-key']}/${withNavigation}`,
                                                            )
                                                  }
                                              >
                                                  {props.children}
                                              </tr>
                                          );
                                      },
                                  },
                              }
                            : null
                    }
                    rowKey={setRowKey}
                    columns={generateTableHeader(tableHeader)}
                    dataSource={
                        getFilteredData
                            ? getFilteredData(data, filter, selectedOption.id)
                            : data
                    }
                    pagination={false}
                    scroll={tableScroll}
                />
            </LocalLoader>
        </>
    );
}
